import React from "react";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import AboutPage from "./Pages/AboutPage"; // Example About page
import AdminBlogTable from "./Pages/AdminTable.js";
import BlogDetailPage from "./Pages/BlogDetailPage.js";
import BlogsPage from "./Pages/BlogsPage.js";
import ContactPage from "./Pages/ContactUs.js";
import BlogPostCreator from "./Pages/CreateBlog.js";
import BlogPostEditor from "./Pages/EditBlog.js";
import FAQPage from "./Pages/FaqsPage.js";
import HomePage from "./Pages/HomePage.js";
import PrivacyTermsPage from "./Pages/Privacy.js";
import Register from "./Pages/Register.js";
import Reviews from "./Pages/Reviews.js";
import GraphicDesignService from "./Pages/Services/GraphicDesignService.js";
import SEO from "./Pages/Services/SEO.js";
import SocialMediaManagement from "./Pages/Services/SocialMediaManagement.js";
import SocialMediaMarketing from "./Pages/Services/SocialMediaMarketing.js";
import VideoEditingService from "./Pages/Services/VideoEditingService.js";
import Web from "./Pages/Services/Web.js";
import ServicesPage from "./Pages/ServicesPage.js";

function App() {
  return (
    <Router>
      <Routes>
        {/* Register Page Route */}
        <Route path="/login" element={<Register />} />
        {/* Home Page Route */}
        <Route path="/" element={<HomePage />} />
        {/* About Page Route */}
        <Route path="/about" element={<AboutPage />} />
        {/* Revoews Page Route */}
        <Route path="/reviews" element={<Reviews />} />
        {/* Contact Page Route */}
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route
          path="/services/graphicDesign"
          element={<GraphicDesignService />}
        />
        <Route
          path="/services/videoEditing"
          element={<VideoEditingService />}
        />
        <Route path="/services/WebDevelopment" element={<Web />} />
        <Route
          path="/services/SocialMediaMarketing"
          element={<SocialMediaMarketing />}
        />
        <Route
          path="/services/SocialMediaManagement"
          element={<SocialMediaManagement />}
        />
        <Route path="/services/SEO" element={<SEO />} />
        <Route path="/faqs" element={<FAQPage />} />
        <Route path="/privacy" element={<PrivacyTermsPage />} />
        <Route path="/blog">
          <Route index element={<BlogsPage />} />
          <Route path=":id" element={<BlogDetailPage />} />
          <Route path="admin/view" element={<AdminBlogTable />} />
          <Route path="edit/:id" element={<BlogPostEditor />} />
        </Route>
        <Route path="/blog/add" element={<BlogPostCreator />} />'
      </Routes>
    </Router>
  );
}

export default App;
